import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material"
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp"
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone"
import PhoneIcon from "@mui/icons-material/Phone"
import MessageIcon from "@mui/icons-material/Message"
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
  GroupDataEdit,
  GroupInfoAdvisor,
  GroupInfoAdvisorLeft,
  GroupInfoAdvisorRight,
  GroupInfoContact,
  GroupInfoContactSectionOne,
  GroupInfoContactSectionOneLeft,
  GroupInfoContactSectionOneRight,
  GroupInfoContactSectionThree,
  GroupInfoContactSectionTwo,
  GroupInfoDeactivate,
  GroupInfoDeactivateButton,
  GroupInfoHeader,
  GroupInfoHeaderIconActiveButton,
  GroupInfoHeaderIconWrapper,
  GroupInfoHeaderLeft,
  GroupInfoRegion,
  GroupInfoRegionSectionOne,
  GroupInfoRegionSectionOneLeft,
  GroupInfoRegionSectionTwo,
  GroupInfoRegionSectionTwoLeft,
  GroupInfoRegionSectionTwoRight,
  GroupInfoWrapper,
  groupInfoIconStyle,
} from "./Atom"
import { StatusButton } from "../../Button"
import { useEffect, useState } from "react"
import UserActivationConfirmation from "../../Modal/UserActivationConfirmation"
import { useSelector } from "react-redux"
import ChangeRoleModal from "../../Modal/ChangeRole"
import UserDeleteModal from "../../Modal/UserDeleteModal"
import UserAPI from "../../../../api/user"
import { getTokenLocal } from "../../../../helper/utils"
import { useResponseHandle } from "../../../hooks"
import { useNavigate } from "react-router-dom"
import UsersAPI from "../../../../api/users"
import moment from "moment"
import { permissions } from "../../../../config/constants"

const userAPI = new UserAPI()
const usersAPI = new UsersAPI()
function UserInfo(props: any) {
  const { fetchUserDetails } = props
  const token: any = getTokenLocal()
  const navigate = useNavigate()
  const allPerms = useSelector((state: any) => {
    return state.rolesAndPerms.userPerms
  })
  const userProfileData = useSelector(
    (state: any) => state.user?.userProfileData,
  )

  const [activationStatus, setActivationStatus] = useState(
    userProfileData?.basic_details?.status,
  )
  const [changeRoleType, setChangeRoleType] = useState("edit")
  const [changeRoleModalopen, setChangeRoleModalopen] = useState(false)
  const [isDeleteButtonActive, setIsDeleteButtonActive] = useState(true)
  const [isActivationButtonDisabled, setIsActivationButtonDisabled] =
    useState(false)

  const [statusConfirmationDialogOpen, setStatusConfirmationDialogOpen] =
    useState(false)
  const [
    handleDeletionConfirmationDialogOpen,
    setHandleDeletionConfirmationDialogOpen,
  ] = useState(false)

  useEffect(() => {
    setActivationStatus(userProfileData?.basic_details?.status)
  }, [userProfileData])

  const handleActivationStatus = () => {
    setStatusConfirmationDialogOpen(true)
  }
  const handleDeletionStatus = () => {
    setHandleDeletionConfirmationDialogOpen(true)
  }

  const handleClickRoleAdd = () => {
    setChangeRoleType("add")
    setChangeRoleModalopen(true)
  }
  const handleClickRoleEdit = () => {
    setChangeRoleType("edit")
    setChangeRoleModalopen(true)
  }

  const handleDeleteUser = async () => {
    setIsDeleteButtonActive(false)
    setHandleDeletionConfirmationDialogOpen(true)
    const response = await userAPI.deleteUserByUid(
      token,
      userProfileData?.basic_details.uid,
    )
    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        setIsDeleteButtonActive(false)
        navigate("/users")
        return
      }
      fetchUserDetails()
      setIsDeleteButtonActive(true)
    }
  }

  const handleResendInvitation = async () => {
    console.log("handleResendInvitation")
    const response = await usersAPI.resendInvitation(
      token,
      userProfileData?.basic_details.uid,
    )
    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })
    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        return
      }
    }
  }

  const deactivateUser = async () => {
    const response = await usersAPI.updateUserStatus(
      token,
      userProfileData?.basic_details?.uid,
      "inactive",
    )
    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        setActivationStatus("inactive")
        setIsActivationButtonDisabled(false)
      }
      setIsActivationButtonDisabled(false)
      fetchUserDetails()
    } else {
      setIsActivationButtonDisabled(false)
      navigate("/auth")
    }

    return result
  }

  const reactivateUser = async () => {
    const response = await usersAPI.updateUserStatus(
      token,
      userProfileData?.basic_details?.uid,
      "active",
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        setActivationStatus("active")
        setIsActivationButtonDisabled(false)
      }
      setIsActivationButtonDisabled(false)
      fetchUserDetails()
    } else {
      setIsActivationButtonDisabled(false)
      navigate("/auth")
    }
    return result
  }

  return (
    <>
      <GroupInfoWrapper>
        {/* Group Info Header Section */}
        <GroupInfoHeader>
          <GroupInfoHeaderLeft>
            <GroupInfoHeaderIconWrapper>
              <AccountCircleSharpIcon sx={[{ fontSize: "50px" }]} />
              <StatusButton
                status={userProfileData?.basic_details?.status}
                fontSize={10}
                padding="small"
              />
            </GroupInfoHeaderIconWrapper>

            <Box sx={{ marginLeft: "18px", width: "100%" }}>
              <Typography
                fontWeight={500}
                color={"#414241"}
                fontSize={18}
                sx={{ whiteSpace: "nowrap" }}
              >
                {userProfileData?.basic_details?.name}
              </Typography>
              {userProfileData?.basic_details?.role_displayname ? (
                <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                  <Typography
                    fontWeight={400}
                    color={"#147AD6"}
                    fontSize={14}
                    sx={{
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    textTransform={"capitalize"}
                  >
                    {userProfileData?.basic_details?.role_displayname}
                  </Typography>
                  {allPerms.includes(permissions?.UPDATE_USER) && (
                    <IconButton
                      sx={{ alignSelf: "flex-start" }}
                      onClick={handleClickRoleEdit}
                    >
                      <EditTwoToneIcon
                        sx={{
                          color: "#707070",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        fontSize="small"
                      />
                    </IconButton>
                  )}
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    cursor: "pointer",
                  }}
                >
                  <Button onClick={handleClickRoleAdd}>
                    <Typography
                      fontWeight={400}
                      color={"#147AD6"}
                      fontSize={14}
                      sx={{
                        whiteSpace: "nowrap",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      Assign A Role
                    </Typography>
                  </Button>
                </Box>
              )}
            </Box>
          </GroupInfoHeaderLeft>
        </GroupInfoHeader>
        {/* contact details */}

        <GroupInfoContact>
          <GroupDataEdit>
            <GroupInfoContactSectionTwo>
              <Typography color={"#707170"} fontSize={12} fontWeight={400}>
                Email ID
              </Typography>
              <Typography color={"#414241"} fontSize={14} fontWeight={500}>
                {userProfileData?.basic_details?.email}
              </Typography>
            </GroupInfoContactSectionTwo>
          </GroupDataEdit>
          <GroupDataEdit>
            <GroupInfoContactSectionTwo>
              <Typography
                color={"#707170"}
                fontSize={"12px"}
                marginTop={"20px"}
              >
                Contact Number
              </Typography>
              <Typography color={"#414241"} fontSize={"14px"}>
                {userProfileData?.basic_details?.contact_number || "N/A"}
              </Typography>
            </GroupInfoContactSectionTwo>
          </GroupDataEdit>

          <GroupInfoContactSectionThree>
            <Typography color={"#707170"} fontSize={"12px"}>
              Created at
            </Typography>
            <Typography color={"#414241"} fontSize={"14px"}>
              {moment(userProfileData?.basic_details?.createdAt).format(
                "MM/DD/YYYY",
              )}
            </Typography>
          </GroupInfoContactSectionThree>
        </GroupInfoContact>

        <GroupInfoDeactivate>
          {allPerms.includes(permissions?.DEACTIVATE_USER) && (
            <GroupInfoDeactivateButton
              variant="text"
              onClick={handleActivationStatus}
            >
              {activationStatus === "inactive" ? "Reactivate" : "Deactivate"}
            </GroupInfoDeactivateButton>
          )}
          {allPerms.includes(permissions?.DELETE_USER) && (
              <GroupInfoDeactivateButton
                variant="text"
                disabled={!isDeleteButtonActive}
                onClick={handleDeletionStatus}
                sx={{ marginLeft: "10px" }}
              >
                Delete
              </GroupInfoDeactivateButton>
            )}
        </GroupInfoDeactivate>
        {userProfileData?.basic_details?.status == "invited" &&
          allPerms.includes(permissions?.INVITE_USER) && (
            <Button
              color="secondary"
              onClick={handleResendInvitation}
              variant="contained"
              sx={{ width: "90%", margin: "-10px auto 10px" }}
            >
              Resend invitation
            </Button>
          )}
      </GroupInfoWrapper>
      <ChangeRoleModal
        open={changeRoleModalopen}
        setOpen={setChangeRoleModalopen}
        type={changeRoleType}
        userUID={userProfileData?.basic_details?.uid}
        fetchUserDetails={fetchUserDetails}
      />
      <UserActivationConfirmation
        open={statusConfirmationDialogOpen}
        setOpen={setStatusConfirmationDialogOpen}
        type={activationStatus === "inactive" ? "reActivate" : "deActivate"}
        isUser
        selectedUser={userProfileData?.basic_details}
        deactivateUser={deactivateUser}
        reactivateUser={reactivateUser}
        setIsActivationButtonDisabled={setIsActivationButtonDisabled}
      />
      <UserDeleteModal
        open={handleDeletionConfirmationDialogOpen}
        setOpen={setHandleDeletionConfirmationDialogOpen}
        deleteUser={handleDeleteUser}
        name={userProfileData?.basic_details?.name}
      />
    </>
  )
}
export default UserInfo
